import React from "react"
import PropTypes from "prop-types"
import { Field } from "react-final-form"
import { Radio, RadioGroup, FormControlLabel, FormControl, FormHelperText } from "@mui/material"

export const RadioField = ({ name, options, values }) => (
  <Field type="radio" name={name}>
    {({ input, meta }) => (
      <FormControl error={meta.touched && meta.error}>
        <RadioGroup
          {...input}
          row
          sx={{
            gap: 1,
            alignItems: "center",
          }}
        >
          {options.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              value={value}
              control={<Radio size="small" />}
              label={label}
              checked={values[name] === value}
            />
          ))}
        </RadioGroup>
        {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}
      </FormControl>
    )}
  </Field>
)

RadioField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  values: PropTypes.object.isRequired,
}
